<template>
		<div>
			<vue-headful
				title="Estándares de Calidad"
				description="En Varelab trabajamos día a día bajo estándares de calidad para ofrecer un servicio con atención personalizada donde el paciente recibe contención tanto profesional como emocional."
			/>
			<div class="front front--page">
				<div v-parallax="0.1" class="bg-parallax bg-parallax--estandares"></div>
				<div class="container">
					<h1 class="title title--big color--white">Estándares de calidad</h1>
					<div class="separator separator--white"></div>
				</div>
			</div>
			
			<div class="page-body">
				<div class="container">
						<h2 class="color--light-blue">En Varelab trabajamos día a día bajo estándares de calidad para ofrecer un servicio con atención personalizada donde el paciente recibe contención tanto profesional como emocional. </h2>
			
						<div class="page-block">
							<p class="color--gray">
								Realizamos los más de 2000 estudios avalados por el Colegio de Bioquímicos de la Provincia de Buenos Aires y la Fundación Bioquímica Argentina (FBA). A su vez contamos con certificaciones emitidas por dichas entidades, controles de calidad externos (PEEC), e internos (Biosystems) y la supervisión permanente efectuada por profesionales en cada área del laboratorio. 
							</p> <br>
							<p class="color--gray">
								Nuestro laboratorio se encuentra equipado con instrumental de alta gama (Systex, Incca, Horiba, Metrolab, entre otros).
							</p>
						</div>
						<img src="../../assets/img/institucional-marcas.png" height="194" width="1095" alt="" class="img-responsive center-block" style="width: 100%">
						<div class="row">
							<div class="col-sm-10 col-sm-offset-1">
								<img src="../../assets/img/institucional-marcas-2.png" height="194" width="1095" alt="" class="img-responsive center-block">
							</div>
						</div>
					</div>
			</div>
		</div>
</template>

<script>
export default {
	name: 'estandares'
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Institucional/Estandares.vue